// extracted by mini-css-extract-plugin
module.exports = {"cardsContainer":"integrations_cardsContainer__1nxtH"};